import { createFormHookContexts, createFormHook } from "@tanstack/react-form";
import { TextField } from "./components/TextField";
import { SubmitButton } from "./components/SubmitButton";
import { NumberSelectField } from "./components/NumberField";
import { SelectField } from "./components/SelectField";
import { SwitchField } from "./components/SwitchField";
import { SliderField } from "./components/SliderField";
import { PhoneField } from "./components/PhoneField";
import { OTPField } from "./components/OTPField";

export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();

export const { useAppForm, withForm, withFieldGroup } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextField,
    NumberSelectField,
    SelectField,
    SwitchField,
    SliderField,
    PhoneField,
    OTPField,
  },
  formComponents: {
    SubmitButton,
  },
});
